import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=2d3bee76&scoped=true&lang=pug&"
import script from "./LostPassword.vue?vue&type=script&lang=ts&"
export * from "./LostPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=2d3bee76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bee76",
  null
  
)

export default component.exports